import * as React from 'react'
import { StyledEngineProvider } from '@mui/material/styles'

export const GlobalCssPriority = ({ children }) => (
    <StyledEngineProvider injectFirst>
        {/* Your component tree. Now you can override Material UI's styles. */}
        {children}
    </StyledEngineProvider>
)
